// config.js
const telegramConfig = {
    botToken: "7716106300:AAEXCNgldC0PrqC2DBJ6vDkbmgSBi7NpGNc", // Replace with your Telegram Bot Token
    chatId: "5481073937",    // Replace with your Telegram Chat ID
  };
  
  export default telegramConfig;